import { type Theme } from "@mui/material";

import { type MuiThemeComponentOverride } from "./types";

export function getMuiList(_theme: Theme): MuiThemeComponentOverride<"MuiList"> {
  return {
    MuiList: {
      styleOverrides: { root: { " .MuiList-root": { padding: "0 0 0 16px" }, paddingBottom: 0, paddingTop: 0 } },
    },
  };
}
